import { TelemetryIdResolver } from '@cv-invision/cv.component-library.ux';
import { Store } from '@ngxs/store';
import { UserContextState } from '../auth/user-context.state';
import { Injectable } from '@angular/core';
@Injectable()
export class IntelligenceIdResolver implements TelemetryIdResolver {
	constructor(private store: Store) {}

	/**
	 * Method to get the user id of intelligence
	 */
	getId(): string {
		const user = this.store.selectSnapshot(UserContextState.getUserContext);
		if (user) {
			return user.id;
		}
		return '';
	}

	/**
	 * Method to get the user cv connection of intelligence
	 */
	getConnection(): string {
		const user = this.store.selectSnapshot(UserContextState.getUserContext);
		if (user) {
			return user.cvConnection;
		}
		return '';
	}
}
